import { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import { toast } from "Layout/slice";
import { parseErrorMessage } from "utils";
import { Button } from "components/Button";
import { Loader } from "components/Loader";
import { pauseCircleV2 } from "assets/icons";
import { pauseStrategy } from "features/Strategy/service";
import { StartStrategyModalContainer } from "./StartStrategyModal.styles";

const PauseStrategyModal = ({
  show = true,
  onHide,
  handlePauseClick,
  subscriptionId,
  strategyName,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handlePause = async () => {
    try {
      setLoading(true);

      await pauseStrategy(subscriptionId);
      onHide();
      handlePauseClick();
    } catch (error) {
      dispatch(
        toast({
          type: "error",
          body: parseErrorMessage(error),
        })
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <StartStrategyModalContainer
      heading=""
      show={show}
      onHide={onHide}
      headingClass="modal-heading"
    >
      <div>
        <div className="d-flex justify-content-center ">
          <img src={pauseCircleV2} className="img" />
        </div>
        <div className="strategy-modal-header ">
          <h2 className="heading">Pause Strategy</h2>
          <p className="description">
            This will pause your portfolio automatically following the trades of{" "}
            {strategyName} (your subscription will remain active)
          </p>
        </div>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <div className="strategy-modal-footer">
          <Button
            onClick={onHide}
            label="Cancel"
            variant="secondary"
            className="cancel-btn button-outlined"
          />
          <Button
            label="Pause Strategy"
            className="start-btn"
            onClick={handlePause}
          />
        </div>
      )}
    </StartStrategyModalContainer>
  );
};

export default PauseStrategyModal;

PauseStrategyModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  handlePauseClick: PropTypes.func,
  subscriptionId: PropTypes.string.isRequired,
  strategyName: PropTypes.string,
};

PauseStrategyModal.displayName = "PauseStrategyModal";
